/** Strings of the workItemDetail screens: `en` is the source, `cs` must have the same keys. */
export const workItemDetailEn = {
  workItemDetail: {
    breadcrumbWorkItems: "Work Items",
    prev: "Prev",
    next: "Next",
    waitingOnClient: "⏸ Waiting on client",
    opened: "Opened",
    openedBy: "by {{name}}",
    description: "Description",
    noDescription: "No description provided.",
    tabComments: "Comments",
    tabAgents: "Agents",
    tabHistory: "History",
    tabTime: "Time entries",
    tabAiSpend: "AI spend",
    tabAttachments: "Attachments",
    info: "Info",
    team: "Team",
    managerControls: "Manager controls",
    priorityLabel: "Priority",
    project: "Project",
    customer: "Customer",
    assignee: "Assignee",
    unassigned: "Unassigned",
    author: "Author",
    created: "Created",
    updated: "Updated",
    closed: "Closed",
    startDate: "Start date",
    priority: {
      urgent: "urgent",
      high: "high",
      normal: "normal",
      low: "low",
    },
    comments: {
      deleted: "Comment deleted",
      deleteFailed: "Delete failed",
      updated: "Comment updated",
      editFailed: "Edit failed",
      confirmDelete: "Delete this comment? This can't be undone.",
      empty: "Comment cannot be empty",
      select: "Select comment",
      edit: "Edit comment",
      delete: "Delete comment",
      cancel: "Cancel",
      saving: "Saving…",
      save: "Save",
      hideHistory: "Hide edit history ({{count}})",
      showHistory: "Show edit history ({{count}})",
      bulkDeleted: "Comments deleted",
      reassignFailed: "Comment posted, reassign failed",
      posted: "Comment posted",
      postFailed: "Failed to post comment",
      none: "No comments yet.",
      bulkDelete: "Delete",
      bulkTitle: "Delete comments",
      bulkConfirm_one:
        "Are you sure you want to permanently delete {{count}} comment? Any linked GitLab notes are deleted too. This can't be undone.",
      bulkConfirm_few:
        "Are you sure you want to permanently delete {{count}} comments? Any linked GitLab notes are deleted too. This can't be undone.",
      bulkConfirm_other:
        "Are you sure you want to permanently delete {{count}} comments? Any linked GitLab notes are deleted too. This can't be undone.",
      deleting: "Deleting…",
      placeholder: "Write a comment…",
      reassign: "Reassign (optional)",
      keepCurrent: "— keep current —",
      post: "Post Comment",
      posting: "Posting",
    },
    history: {
      none: "No history yet.",
      system: "System",
      changed: "changed",
      from: "from",
      to: "to",
    },
    timeEntries: {
      none: "No time entries.",
      user: "User",
      date: "Date",
      time: "Time",
      hours: "Hours",
      external: "External user",
      total: "Total",
    },
    attachments: {
      title: "Attachments",
      couldntAttach: "Couldn't attach {{name}}",
      networkError: "Network error",
      confirmRemove: "Remove {{name}}?",
      couldntRemove: "Couldn't remove attachment",
      uploading: "Uploading…",
      pick: "Pick files",
      empty: 'Drop files here or click "Pick files" to attach.',
      remove: "Remove {{name}}",
    },
    inline: {
      titleUpdated: "Title updated",
      descriptionUpdated: "Description updated",
      saveFailed: "Save failed",
      titleEmpty: "Title can't be empty",
      editTitle: "Edit title",
      editDescription: "Edit description",
      placeholder: "Describe the work item… (Markdown supported)",
      saving: "Saving…",
      save: "Save",
      cancel: "Cancel",
      hint: "Markdown supported · Esc to cancel",
      patchUpdated: "{{field}} updated",
      patchFailed: "{{field}} update failed",
      requestFailed: "Request failed",
      apply: "Apply",
    },
    sidebar: {
      thanks: "Thanks, the team is back on it",
      couldntSendBack: "Couldn't send it back",
      answered: "I've answered",
      noLongerWatching: "No longer watching",
      watching: "Watching this work item",
      watchFailed: "Watch toggle failed",
      unwatch: "Unwatch",
      watch: "Watch",
      watchers: "Watchers ({{count}})",
      noWatchers: "No watchers yet.",
      datesProgress: "Dates & Progress",
      datesProgressField: "Dates & progress",
      save: "Save",
      dueDate: "Due date",
      estimatedHours: "Estimated hours",
      spent: "Spent",
    },
    editor: {
      bold: "Bold",
      italic: "Italic",
      heading: "Heading",
      code: "Code",
      quote: "Quote",
      bulletList: "Bullet list",
      numberedList: "Numbered list",
      checklist: "Checklist",
      link: "Link",
      image: "Image",
      uploadFailed: "Upload failed",
      networkError: "Network error",
      insertTable: "Insert table",
      attachFile: "Attach file",
      edit: "Edit",
      preview: "Preview",
      nothingToPreview: "Nothing to preview.",
    },
    standalone: "TASK",
  },
};
export const workItemDetailCs: typeof workItemDetailEn = {
  workItemDetail: {
    breadcrumbWorkItems: "Tikety",
    prev: "Předchozí",
    next: "Další",
    waitingOnClient: "⏸ Čeká na klienta",
    opened: "Založeno",
    openedBy: "uživatelem {{name}}",
    description: "Popis",
    noDescription: "Bez popisu.",
    tabComments: "Komentáře",
    tabAgents: "Agenti",
    tabHistory: "Historie",
    tabTime: "Odpracovaný čas",
    tabAiSpend: "Náklady na AI",
    tabAttachments: "Přílohy",
    info: "Informace",
    team: "Tým",
    managerControls: "Správa manažera",
    priorityLabel: "Priorita",
    project: "Projekt",
    customer: "Zákazník",
    assignee: "Přiřazeno",
    unassigned: "Nepřiřazeno",
    author: "Autor",
    created: "Vytvořeno",
    updated: "Upraveno",
    closed: "Uzavřeno",
    startDate: "Datum zahájení",
    priority: {
      urgent: "naléhavá",
      high: "vysoká",
      normal: "normální",
      low: "nízká",
    },
    comments: {
      deleted: "Komentář smazán",
      deleteFailed: "Smazání se nepodařilo",
      updated: "Komentář upraven",
      editFailed: "Úprava se nepodařila",
      confirmDelete: "Smazat tento komentář? Nelze to vrátit zpět.",
      empty: "Komentář nesmí být prázdný",
      select: "Vybrat komentář",
      edit: "Upravit komentář",
      delete: "Smazat komentář",
      cancel: "Zrušit",
      saving: "Ukládám…",
      save: "Uložit",
      hideHistory: "Skrýt historii úprav ({{count}})",
      showHistory: "Zobrazit historii úprav ({{count}})",
      bulkDeleted: "Komentáře smazány",
      reassignFailed: "Komentář odeslán, přiřazení se nepodařilo",
      posted: "Komentář odeslán",
      postFailed: "Komentář se nepodařilo odeslat",
      none: "Zatím žádné komentáře.",
      bulkDelete: "Smazat",
      bulkTitle: "Smazat komentáře",
      bulkConfirm_one:
        "Opravdu chcete trvale smazat {{count}} komentář? Propojené poznámky v GitLabu se smažou také. Nelze to vrátit zpět.",
      bulkConfirm_few:
        "Opravdu chcete trvale smazat {{count}} komentáře? Propojené poznámky v GitLabu se smažou také. Nelze to vrátit zpět.",
      bulkConfirm_other:
        "Opravdu chcete trvale smazat {{count}} komentářů? Propojené poznámky v GitLabu se smažou také. Nelze to vrátit zpět.",
      deleting: "Mažu…",
      placeholder: "Napište komentář…",
      reassign: "Přiřadit jinému (volitelné)",
      keepCurrent: "— ponechat stávajícího —",
      post: "Odeslat komentář",
      posting: "Odesílám",
    },
    history: {
      none: "Zatím žádná historie.",
      system: "Systém",
      changed: "změnil(a)",
      from: "z",
      to: "na",
    },
    timeEntries: {
      none: "Žádné záznamy času.",
      user: "Uživatel",
      date: "Datum",
      time: "Čas",
      hours: "Hodiny",
      external: "Externí uživatel",
      total: "Celkem",
    },
    attachments: {
      title: "Přílohy",
      couldntAttach: "Soubor {{name}} se nepodařilo přiložit",
      networkError: "Chyba sítě",
      confirmRemove: "Odebrat {{name}}?",
      couldntRemove: "Přílohu se nepodařilo odebrat",
      uploading: "Nahrávám…",
      pick: "Vybrat soubory",
      empty: "Přetáhněte soubory sem nebo klikněte na „Vybrat soubory“.",
      remove: "Odebrat {{name}}",
    },
    inline: {
      titleUpdated: "Název upraven",
      descriptionUpdated: "Popis upraven",
      saveFailed: "Uložení se nepodařilo",
      titleEmpty: "Název nesmí být prázdný",
      editTitle: "Upravit název",
      editDescription: "Upravit popis",
      placeholder: "Popište tiket… (podporuje Markdown)",
      saving: "Ukládám…",
      save: "Uložit",
      cancel: "Zrušit",
      hint: "Podporuje Markdown · Esc zruší",
      patchUpdated: "{{field}}: uloženo",
      patchFailed: "{{field}}: uložení se nepodařilo",
      requestFailed: "Požadavek se nezdařil",
      apply: "Použít",
    },
    sidebar: {
      thanks: "Díky, tým na tom zase pracuje",
      couldntSendBack: "Vrácení se nepodařilo",
      answered: "Odpověděl(a) jsem",
      noLongerWatching: "Už nesledujete",
      watching: "Sledujete tento tiket",
      watchFailed: "Změna sledování se nepodařila",
      unwatch: "Přestat sledovat",
      watch: "Sledovat",
      watchers: "Sledující ({{count}})",
      noWatchers: "Zatím nikdo nesleduje.",
      datesProgress: "Termíny a průběh",
      datesProgressField: "Termíny a průběh",
      save: "Uložit",
      dueDate: "Termín",
      estimatedHours: "Odhad hodin",
      spent: "Odpracováno",
    },
    editor: {
      bold: "Tučně",
      italic: "Kurzíva",
      heading: "Nadpis",
      code: "Kód",
      quote: "Citace",
      bulletList: "Odrážkový seznam",
      numberedList: "Číslovaný seznam",
      checklist: "Zaškrtávací seznam",
      link: "Odkaz",
      image: "Obrázek",
      uploadFailed: "Nahrání se nepodařilo",
      networkError: "Chyba sítě",
      insertTable: "Vložit tabulku",
      attachFile: "Přiložit soubor",
      edit: "Upravit",
      preview: "Náhled",
      nothingToPreview: "Není co zobrazit.",
    },
    standalone: "ÚKOL",
  },
};
